import { locationService } from "Apis";
import { useParentChildSharedState } from "./useSharedState";
import { ApiLocation, ApiProject } from "@incendium/api";


const defaultLocation: ApiLocation = {
  name: "",
  urlMatch: "",
  items: [],
  showInAnalytics: true,
};

export const useLocations = (locationId?: number) => {


  const fetchLocations = async (project: ApiProject) => {
    const locations = await locationService.locationServiceListLocations({
      projectId: project.id as number,
    });
    return locations.results || [];
  };

  const fetchLocation = async (project: ApiProject) => {
    if (!locationId) return defaultLocation;

    const res = await locationService.locationServiceReadLocation({
      projectId: project.id as number,
      locationId,
    });
    return res.result || defaultLocation;
  };

  const {
    state,
    setState,
    childState,
    setChildState,
    refetch,
    loading,
    resetEmpty,
  } = useParentChildSharedState<ApiLocation[], ApiLocation>(
    "locations",
    [],
    defaultLocation,
    locationId || 0,
    fetchLocations,
    fetchLocation
  );

  return {
    loading,
    locations: state,
    setLocations: setState,
    refetchLocations: refetch,
    location: childState,
    setLocation: setChildState,
    resetEmpty,
  };
};
